import Core from "@/modules/core/service/Core";

const url = {
    recipients: "/api/site/recipients",
    init      : "/api/company/{0}/contact",
    create    : "/api/company/contact",
    contact   : "/api/company/contact/{0}",
    assign    : "/api/contact/{0}/assign/{1}",
    dissolve  : "/api/contact/{0}/dissolve/{1}",
    move      : "/api/contact/{0}/move",
    remove    : "/api/company/contact/removed"
};

export default {
    roles: {
        customerContact: 1,
        onsite         : 2
    },

    isGlobal (contact) {
        return contact.siteAssignmentType && contact.siteAssignmentType.id === 2;
    },

    isGlobalCustomer (contact) {
        return contact.siteAssignmentType && contact.siteAssignmentType.id === 3;
    },

    assign (contact, site) {
        return Core.method.postVoid(url.assign,null,  contact.id, site.id);
    },

    dissolve (contact, siteId) {
        return Core.method.postVoid(url.dissolve, null,  contact.id, siteId);
    },

    move (sourceId, targetId) {
        const body = {
            sourceId: sourceId,
            targetId: targetId
        };

        return Core.method.post(url.move, body, sourceId);
    },

    findById (contactId, success) {
        Core.method.get(url.contact, contactId).then((data) => success (data));
    },

    store (contact, success) {
        if (!contact.id) {
            Core.method.post(url.create, contact).then((data) => success(data))
            return;
        }

        Core.method.put (url.contact, contact, contact.id).then((data) => success(data));
    },

    create (companyId, success) {
        Core.method.get(url.init, companyId).then ((data) => success(data));
    },

    recipients (incident, statusId, companyId, roles) {
        const body = {
            siteIds  : incident.sites.map(s => s.id),
            roleIds  : roles,
            typeId   : incident.typeId,
            statusId : statusId,
            companyId: companyId,
        };

        return Core.method.post(url.recipients, body);
    },

    findRemoved () {
        return Core.method.get(url.remove);
    },

    remove () {
        return Core.method.delete(url.remove);
    },

    filter (contact, text) {
        if (!text) {
            return true;
        }

        if (Core.filter.includes(contact.name, text)) {
            return true;
        }

        if (Core.filter.includes(contact.firstname, text)) {
            return true;
        }

        if (Core.filter.includes(contact.tags, text)) {
            return true;
        }

        return false;
    }
}